<template>
  <!-- Innovadis custom: product-card--search-result class-->
  <VcProductCard view-mode="list" class="product-card--search-result">
    <router-link :to="link" class="contents" @click="$emit('linkClick', $event)">
      <VcProductImage :img-src="product.imgSrc" :alt="productName" size-suffix="sm" lazy />
    </router-link>

    <div class="flex flex-col">
      <!-- Innovadis custom: product-title--search-result class-->
      <VcProductTitle
        :lines-number="2"
        fix-height
        :to="link"
        :title="productName"
        @click="$emit('linkClick', $event)"
        class="product-title--search-result"
      >
        {{ productName?.trim() }}
      </VcProductTitle>

      <span>
        {{ product.code }}
      </span>

      <!-- BB2B-122 Hide price on product tile for now due to performance issues on min variation price
       <InnoProductPrice
        :actual-price="product.minVariationPrice?.actual ?? product.price.actual"
        :list-price="product.minVariationPrice?.list ?? product.price.list"
        :with-from-label="product.hasVariations || product.isConfigurable"
        :price-unit-text="priceUnitText"
      /> -->
    </div>
  </VcProductCard>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getProductName, getProductRoute } from "@/core/utilities";
import type { Product } from "@/core/api/graphql/types";
import type { RouteLocationRaw } from "vue-router";
//import { getProductPriceUnitText } from "@/core/utilities/innovadis";
//import InnoProductPrice from "@/ui-kit//components/molecules/innovadis/inno-product-price.vue";

interface IEmits {
  (eventName: "linkClick", globalEvent: PointerEvent): void;
}

interface IProps {
  product: Product;
}

defineEmits<IEmits>();
const props = defineProps<IProps>();

//const price = computed(() => (props.product.hasVariations ? props.product.minVariationPrice : props.product.price));

const link = computed<RouteLocationRaw>(() => getProductRoute(props.product.id, props.product.slug));

// Innovadis custom: price unit text
//const priceUnitText = computed(() => getProductPriceUnitText(props.product));

// Innovadis custom: get product name - note: at the moment the search products graphql product response has no properties, so prefixing article group name is not possible
const productName = computed(() => getProductName(props.product, true));
</script>

<style>
/* Innovadis custom styles */
.product-card--search-result {
  .vc-product-card__wrapper {
    @apply flex items-start !important;
  }
}

.product-title--search-result {
  @apply h-auto mt-1 self-start !important;
}
</style>
